import React from 'react';
import { WIZARD_STEPS } from '../constants/wizardSteps';

const EventWizardStepper = ({
  currentStep,
  onStepClick,
  completedSteps = [],
  allowAllSteps = false,
  steps = WIZARD_STEPS,
}) => (
  <nav aria-label="Event creation progress" className="px-4 sm:px-6 pt-4 pb-2 border-b border-gray-200 dark:border-gray-700 bg-gray-50/80 dark:bg-gray-900/40">
    <ol className="flex items-center gap-1 overflow-x-auto pb-1 scrollbar-thin">
      {steps.map((step, index) => {
        const isActive = step.id === currentStep;
        const isComplete = completedSteps.includes(step.id);
        const canJump = allowAllSteps
          || isComplete
          || index <= steps.findIndex((s) => s.id === currentStep);
        return (
          <li key={step.id} className="flex items-center flex-shrink-0">
            <button
              type="button"
              disabled={!canJump}
              onClick={() => canJump && onStepClick?.(step.id)}
              className={`flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-medium transition-colors ${
                isActive
                  ? 'bg-emerald-600 text-white'
                  : isComplete
                    ? 'text-emerald-700 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-emerald-950/40'
                    : canJump
                      ? 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                      : 'text-gray-400 cursor-default'
              }`}
            >
              <span className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold ${
                isActive
                  ? 'bg-white/25 text-white'
                  : isComplete
                    ? 'bg-emerald-500 text-white'
                    : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
              }`}>
                {isComplete && !isActive ? '✓' : index + 1}
              </span>
              <span className="hidden sm:inline">{step.shortLabel}</span>
            </button>
            {index < steps.length - 1 && (
              <span className={`mx-0.5 ${isComplete ? 'text-emerald-300 dark:text-emerald-700' : 'text-gray-300 dark:text-gray-600'}`}>→</span>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default EventWizardStepper;
